// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"2f307caed6918fe1","5763":"8e13692f765cd387","6893":"72cbda602291f672","6974":"bfd19ff2f7d0eb69","7222":"f77b9f3b10c096a9","7937":"43524bd3a32c8c8c"}[chunkId] + ".js";
};